/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-content[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]{margin-top:6px}.mat-dialog-content[_ngcontent-%COMP%]   .upgrade-checkbox[_ngcontent-%COMP%]{margin-top:16px}"];
export { styles as styles };
